<script lang="ts">
import AbgesicherterBereich from "@/components/abgesichert/AbgesicherterBereich.vue";
import EmailOderHerunterladen from "@/components/vorschlag/EmailOderHerunterladen.vue";
import IconSprite from "@/components/IconSprite.vue";
import Infotext from "@/components/Infotext.vue";
import ValidierungsFehler from "@/components/ValidierungsFehler.vue";
import { defineComponent } from "vue";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "AbschlussMakler",
  components: {
    AbgesicherterBereich,
    EmailOderHerunterladen,
    IconSprite,
    Infotext,
    ValidierungsFehler,
  },
  props: {
    zeigeAngabenBestaetigen: Boolean,
    produkt: String,
    fehler: Object,
  },
  setup(props) {
    const piniaStore = useFormStore();

    return {
      props,
      piniaStore,
    };
  },
});
</script>

<template>
  <div v-if="piniaStore.state.isMakler === true" class="o-grid">
    <div class="o-grid__cell o-grid__cell--12">
      <p class="u-mar-t-0">
        Folgende {{ piniaStore.state.isDunkelverarbeitung ? "Vertragsunterlagen" : "Antragsunterlagen" }} hat der
        Versicherungsnehmer erhalten: Das Informationsblatt zu Versicherungsprodukten, das Tarifinformationsblatt, die
        Kundeninformationen (einschließlich Belehrung über das Widerrufsrecht sowie die Hinweise zur vorvertraglichen
        Anzeigepflicht) die Versicherungsbedingungen, die Satzung und die Datenschutzhinweise zur Antrags- und
        Vertragsbearbeitung.
      </p>
      <div
        v-if="props.produkt === 'hg' && piniaStore.state.gebaeudedaten.gewerbeVorhanden === true"
        class="c-form-control-checkbox form-group"
      >
        <br />
        <input
          type="checkbox"
          class="c-form-control-checkbox__input"
          id="gewerbeZulaessigMakler"
          name="gewerbeZulaessigMakler"
          :required="piniaStore.state.gebaeudedaten.gewerbeVorhanden"
          :aria-required="piniaStore.state.gebaeudedaten.gewerbeVorhanden"
          aria-describedby="gewerbehilfe"
          data-fehlermeldung="Bitte bestätigen Sie die Erklärung."
          data-cy="gewerbeZulaessigMaklerOption"
        />
        <label class="c-form-control-checkbox__label" for="gewerbeZulaessigMakler">
          <icon-sprite icon-name="icon-check-mark" css-klassen="c-form-control-checkbox__icon" :ist-klein="true" />
          <span class="c-form-control-checkbox__label-text">
            <slot name="gewerbe-zulaessig"></slot>
          </span>
        </label>
        <span class="c-notice-icon" aria-hidden="true" @click="wechsleSichtbarkeit">
          <icon-sprite icon-name="icon-info-i" />
        </span>
        <Infotext
          role="tooltip"
          id="gewerbehilfe"
          name="gewerbeHilfe"
          text="Die GEV versichert keine Gebäude, in denen
                  grundwassergefährdende Stoffe wie beispielsweise
                  Farben, Lacke, Treibstoffe etc. über den
                  haushaltsüblichen Umfang hinaus gelagert werden.
                  Beispiele: Chemische Reinigungen, Tankstellen,
                  Malereibetriebe, Lackierereien, Entsorgungs- und
                  Recyclingbetriebe, Herstellerbetriebe von Farben und Lacken.<br /> <br />
                  Die GEV versichert keine Gebäude in denen sich z. B.
                  folgende Gewerbearten befinden: Stundenhotels,
                  Bordelle, Discotheken, Nachtclubs und Bars."
        >
        </Infotext>
        <validierungs-fehler :fehler-text="fehler.gewerbeZulaessigMakler" />
      </div>
      <div class="c-form-control-checkbox form-group">
        <br />
        <input
          type="checkbox"
          class="c-form-control-checkbox__input"
          id="schlusserklaerungMakler"
          name="schlusserklaerungMakler"
          required
          aria-required="true"
          data-fehlermeldung="Bitte bestätigen Sie die Erklärung."
          data-cy="schlusserklaerungMaklerOption"
        />
        <label class="c-form-control-checkbox__label" for="schlusserklaerungMakler">
          <icon-sprite icon-name="icon-check-mark" css-klassen="c-form-control-checkbox__icon" :ist-klein="true" />
          <span class="c-form-control-checkbox__label-text">
            Der/die Versicherungsmakler/in bestätigt, dass er stellvertretend im Auftrage seines Mandanten die
            vorstehende Versicherung beantragt und dass ihm die vorbenannten Unterlagen und Informationen zur Verfügung
            stehen.
          </span>
        </label>
        <validierungs-fehler :fehler-text="fehler.schlusserklaerungMakler" />
      </div>
      <div class="c-form-control-checkbox form-group">
        <br />
        <slot name="schlusserklaerungMakler2"></slot>
        <validierungs-fehler :fehler-text="fehler.schlusserklaerungMakler2" />
      </div>
    </div>

    <email-oder-herunterladen :produkt="produkt" :antrag="true" tracking-zusatz="abschluss">
      <template v-slot:button-3>
        <div class="o-grid__cell o-grid__cell--12-360 o-grid__cell--4-1024">
          <abgesicherter-bereich
            :benoetigte-rollen="[
              'STANDARDNUTZER',
              'NUTZER',
              'GESCHAEFTSFUEHRER',
              'NUTZER_NEUGESCHAEFT',
              'GEV_MITARBEITER',
            ]"
            :is-makler-link="piniaStore.state.isMaklerLink"
          >
            <button
              id="btnAbsendenMakler"
              class="c-button c-button--full-width c-button--word-wrap-flex-height u-mar-b-6"
              @click="$emit('antrag-absenden')"
              data-cy="btnAbsendenMakler"
            >
              {{
                piniaStore.state.isDunkelverarbeitung
                  ? "Jetzt abschließen (beitragspflichtig)"
                  : "Jetzt verbindlich beantragen"
              }}
            </button>
          </abgesicherter-bereich>
        </div>
      </template>
    </email-oder-herunterladen>
  </div>
</template>
